export default __webpack_public_path__ + "f2c28e70c46c000389e780b11a10dcaa.png";